import { createGenericApiSlice } from '../../../Api/Factory/genericApiFactory';
import { TagTypes } from '../../../Api/Types/tagTypes';
import { OfferBoardingPlace } from '../../Shared/Types/offerBoardingPlacesTypes';

export const offerBoardingPlacesApi = createGenericApiSlice<OfferBoardingPlace>({
  reducerPath: 'offerBoardingPlacesApi',
  tag: TagTypes.OfferBoardingPlace,
  endpoint: 'offer-boarding-place',
});

export const {
  useGetAllQuery: useGetOfferBoardingPlacesQuery,
  useGetByIdQuery: useGetOfferBoardingPlaceByIdQuery,
  useCreateMutation: useCreateOfferBoardingPlaceMutation,
  useUpdateMutation: useUpdateOfferBoardingPlaceMutation,
  useDeleteMutation: useDeleteOfferBoardingPlaceMutation,
} = offerBoardingPlacesApi;
